<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createFileluConfig } from "./fs";
  import { makeFileSystemFilelu, testFileluConnection } from "./fs-filelu";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createFileluConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing filelu connection");
    try {
      config.apiKey = config.apiKey.trim();
      config.name = config.name.trim();
      await testFileluConnection(config.apiKey);
      if (config.name == "") {
        config.name = "FileLu";
      }
      let fs = makeFileSystemFilelu(config);
      let who = config.name;
      telegramNotify(`New FileLu connection for ${who}`);
      captureEvent("filelu-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect FileLu">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-filelu-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-filelu-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-filelu-key">API key:</label>
      <input
        type="password"
        id="input-filelu-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-3 w-72 text-gray-500">
        Get the key from your
        <a href="https://filelu.com/account/" class="text-blue-600 underline" target="_blank" rel="noreferrer"
          >FileLu account page</a
        >, under developer API key. FileLu cannot rename or move files and keeps no modification times.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect FileLu</button>
    </div>
  {/snippet}
</DialogBase>
